var Upload, UploadAsset,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Upload = (function() {
  function Upload(element, url, options) {
    var default_options;
    this.element = element;
    this.url = url;
    if (options == null) {
      options = {};
    }
    this.enable = __bind(this.enable, this);
    this.disable = __bind(this.disable, this);
    this.callback = __bind(this.callback, this);
    this.remove_file = __bind(this.remove_file, this);
    this.add = __bind(this.add, this);
    default_options = {
      url: this.url,
      maxFileSize: 20000000,
      acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
      dataType: 'json'
    };
    ObservableArray(this, 'files');
    ObservableArray(this, 'assets');
    Observable(this, 'read_iptc', false);
    this.callback('add', (function(_this) {
      return function(e, data) {
        _this.files.push(UploadAsset(data.files[0]));
        return data.uaIndex = _this.files.indexOf(data.files[0]);
      };
    })(this));
    this.callback('progress', (function(_this) {
      return function(e, data) {
        var progress;
        progress = Math.floor(data.loaded / data.total * 100);
        return _this.files()[data.uaIndex].progress(progress);
      };
    })(this));
    this.callback('done', (function(_this) {
      return function(e, data) {
        _this.files()[data.uaIndex].data = data;
        if (data.result.error) {
          _this.files()[data.uaIndex].state(2);
          _this.files()[data.uaIndex].progress(0);
          return _this.files()[data.uaIndex].error(data.result.error);
        } else {
          _this.files()[data.uaIndex].state(1);
          return _this.add(Asset(data.result[0]));
        }
      };
    })(this));
    this.callback('fail', (function(_this) {
      return function(e, data) {
        _this.files()[data.uaIndex].state(2);
        _this.files()[data.uaIndex].progress(0);
        _this.files()[data.uaIndex].error(data.errorThrown.message);
        return _this.files()[data.uaIndex].data = data;
      };
    })(this));
    this.element.fileupload(Ham.merge(options, default_options));
    this.disable();
  }

  Upload.prototype.add = function(asset) {
    api.assets.albums.read(asset.id).done((function(_this) {
      return function(data) {
        var album, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = data.length; _i < _len; _i++) {
          album = data[_i];
          _results.push(asset.albums.push(Album(album)));
        }
        return _results;
      };
    })(this));
    api.assets.galleries.read(asset.id).done((function(_this) {
      return function(data) {
        var gallery, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = data.length; _i < _len; _i++) {
          gallery = data[_i];
          _results.push(asset.galleries.push(Gallery(gallery)));
        }
        return _results;
      };
    })(this));
    if (this.read_iptc()) {
      api.assets.iptc.create(asset.id).done((function(_this) {
        return function() {
          Tag.find(asset.id, function(data) {
            var tag, _i, _len, _results;
            asset.tags([]);
            _results = [];
            for (_i = 0, _len = data.length; _i < _len; _i++) {
              tag = data[_i];
              _results.push(asset.tags.push(Tag(tag)));
            }
            return _results;
          });
          return _this.assets.push(asset);
        };
      })(this));
    } else {
      this.assets.push(asset);
    }
    if (typeof all_tags !== "undefined") {
      return $('.add-tag-input').typeahead({
        local: all_tags
      });
    }
  };

  Upload.prototype.remove_file = function(file) {
    return this.files.remove(file);
  };

  Upload.prototype.callback = function(type, fn) {
    return this.element.bind('fileupload' + type, fn);
  };

  Upload.prototype.disable = function() {
    return this.element.parent().attr('disabled', true);
  };

  Upload.prototype.enable = function() {
    return this.element.parent().attr('disabled', false);
  };

  return Upload;

})();

UploadAsset = function(self) {
  Selectable(self);
  Observable(self, 'progress', 0);
  Observable(self, 'state', 0);
  Observable(self, 'error', false);
  self.retry = (function(_this) {
    return function() {
      self.progress(0);
      self.state(0);
      return self.data.submit();
    };
  })(this);
  return self;
};

//# sourceMappingURL=upload.js.map
